export default __webpack_public_path__ + "static/media/eh_1.adbf241f.png";